var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('main',{staticClass:"confirmRegistration"},[_c('section',[(_vm.isLoading)?_c('div',[_c('section',[(_vm.isLoading)?_c('b-icon',{staticClass:"spinner",attrs:{"icon":"three-dots","animation":"throb"}}):_vm._e()],1)]):_vm._e()])])
}
var staticRenderFns = []

export { render, staticRenderFns }